import { TextFieldInputProps } from '@aircall/tractor';

export type UnitInputValidationTypes = 'success' | 'error';

export const ValidationColors: Record<UnitInputValidationTypes, string> = {
  success: 'colors.green.dark',
  error: 'colors.red.dark',
};

export type UnitInputProps = Omit<TextFieldInputProps, 'variant'> & {
  /** The value of the unit to display (Ex. €, pieces, kg, ml, mins, secs, etc.) */
  unit: string;
  /** Any valid CSS width */
  width?: number | string;
  /** Whether to align the units to the right of the input */
  pullRight?: boolean;
  /** Data test id prop  */
  'data-test'?: string;
  /** Any valid CSS text alignment */
  textAlign?: string;
  /** The validation status to show a different style to the input based on it */
  validationStatus?: UnitInputValidationTypes;
};
